<template>
  <vDialog :visible.sync="visible" :needToBody="true" :visibleFooter="false" @open="resetCheckBox">
    <div class="dialog_body">
      <el-form :model="formData" label-position="top" ref="form" :rules="redeemRules">
        <div class="title">{{ $t('promotion.referFriends.confirmQ') }}</div>
        <div class="title">
          <span class="light_text">{{ $t('promotion.referFriends.amount') }}</span> {{ amount }}
          {{ defaultCurrency }}
        </div>
        <div class="account_div">
          <SelectForm
            v-model="formData.mt4Account"
            name="mt4Account"
            :label="$t('common.field.accNum')"
            prop="mt4Account"
            class="selection_wrapper"
          >
            <el-option
              v-for="(item, index) in accNums"
              :key="index"
              :value="item.mt4Account"
              :label="item.mt4Account + ' - ' + item.currency"
              :data-testid="item.mt4Account"
            ></el-option>
          </SelectForm>
        </div>
        <el-form-item prop="checkCurrency" class="confirmed">
          <el-checkbox v-model="formData.checkCurrency">
            {{
              $t('promotion.referFriends.confirmQ2', {
                amount: updateAmount,
                currency: updateCurrency
              })
            }}
          </el-checkbox>
        </el-form-item>

        <el-form-item class="button_wrapper">
          <el-button class="el-button blue_button" @click="onSubmit">
            {{ $t('promotion.referFriends.redeem') }}
          </el-button>
        </el-form-item>

        <div class="agreeTnc_wrapper">
          <i18n path="promotion.referFriends.agree">
            <template v-slot:link>
              <a :href="tncLink" target="_blank" data-testid="tnc">
                {{ $t('tradingTools.condition.link') }}
              </a>
            </template>
          </i18n>
        </div>
      </el-form>
    </div>
  </vDialog>
</template>

<script>
import vDialog from '@/components/home/vDialog';
import { RAF_INDIA_TNC_LINK, RAF_TNC_LINK } from '@/constants/thirdPartyLink';
import { apiSubmitRedeem } from '@/resource';
import { PROMOTION_TYPE } from '@/constants/promotion';

export default {
  name: 'RedeemPopup',
  components: { vDialog },
  props: {
    redeemVisible: Boolean,
    participantIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    amount: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    campaignId: Number,
    accNums: Array,
    isRafIndia: {
      type: Boolean
    }
  },
  data() {
    const validateCheckCurrency = (rule, value, callback) => {
      if (value) {
        callback();
      } else {
        callback(new Error(this.$t('common.formValidation.answerReq')));
      }
    };
    return {
      defaultCurrency: 'USD',
      visible: this.redeemVisible,
      formData: {
        mt4Account: null,
        campaignId: this.campaignId,
        participantIds: [],
        checkCurrency: false
      },
      redeemRules: {
        mt4Account: [{ required: true, message: this.$t('common.formValidation.accReq'), trigger: 'change' }],
        checkCurrency: [{ required: true, validator: validateCheckCurrency, trigger: 'change' }]
      },
      currency: null,
      convertAmt: 0,
      currentAccount: ''
    };
  },
  computed: {
    updateAmount() {
      if (this.currentAccount) {
        const decPoint = this.currentAccount.currency === 'JPY' ? 0 : 2;

        return (this.convertAmt =
          this.currentAccount.currency === 'USD'
            ? this.amount
            : this.currentAccount.currency === 'USC'
            ? (this.amount * this.currentAccount.exchangeRate).toFixed(decPoint)
            : (this.amount * 0.9 * this.currentAccount.exchangeRate).toFixed(decPoint));
      } else {
        return 0;
      }
    },
    updateCurrency() {
      return (this.currency = this.currentAccount?.currency ? this.currentAccount?.currency : '');
    },
    tncLink() {
      return this.isRafIndia ? RAF_INDIA_TNC_LINK : RAF_TNC_LINK;
    }
  },
  watch: {
    redeemVisible(bool) {
      this.visible = bool;
    },
    visible(bool) {
      this.$emit('update:redeemVisible', bool);
    },
    accNums(accounts) {
      this.formData.mt4Account = accounts[0].mt4Account;
    },
    participantIds(ids) {
      if (ids && Array.isArray(ids)) {
        this.formData.participantIds = ids;
      }
    },
    'formData.mt4Account'(accountId) {
      if (accountId) {
        this.currentAccount = this.accNums.find(e => e.mt4Account === accountId);
      }
    }
  },
  methods: {
    excuteValidate() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          resolve(valid);
        });
      });
    },
    showError() {
      this.$message({
        message: this.$t('common.field.failed'),
        type: 'error',
        duration: 5000
      });
    },
    resetCheckBox() {
      this.$nextTick(() => {
        this.$refs.form.fields.find(f => f.prop == 'checkCurrency').resetField();
      });
    },
    async onSubmit() {
      const isValid = await this.excuteValidate();
      if (!isValid) return;

      if (this.amount === 0) {
        this.$emit('update:redeemVisible', false);
        return;
      }

      return apiSubmitRedeem({
        campaignId: this.formData.campaignId,
        mt4Account: this.formData.mt4Account,
        participantIds: this.formData.participantIds
      })
        .then(({ data }) => {
          const isError = data.data === false;
          if (isError) {
            this.showError();
            return;
          }
          this.$emit('redeemSuccess');
          this.$emit('update:redeemVisible', false);
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/redeem/redeem.scss';
</style>
